import axiosInstance from '@/services/axios';

export default {
  namespaced: true,

  state: {
    video: {},
  },
  actions: {
    fetchVideo ({ state, commit }, alias) {
      const url = `/api/v3/videos/${alias}`;
      return axiosInstance.get(url)
        .then((res) => {
          const video = res.data;
          commit('setVideo', video);
          return state.video;
        });
    },
  },
  mutations: {
    setVideo (state, video) { return state.video = video; },
  },
};
